/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Nikolay Sviridov
 * @version 1.33.0
 * @since 1.33.0
 */

import { IWizardImportSubscribersLimitsReducer } from './wizardImportSubscribersLimitsReducer';


export const warningSettingsDefaultConst = {
    defaultWarningRows: 2,
    maxWarningRows: 10,
    maxNumberWarningTextSymbols: 255,
};


export enum EWizardImportSubscribersLimitsSteps {
    SelectionStep = 'LimitsDocumentSelectionStep',
    ConfirmStep = 'LimitsConfirmImportStep',
}

export const initWizardImportSubscribersLimitsState: IWizardImportSubscribersLimitsReducer = {
    errorCode: '',
    errorRowsAmount: 0,
    importFileFormat: [],
    fileIsLoading: false,
    fileName: '',
    fileRowsAmount: 0,
    fileTemplateUrl: '',
    maxImportSubscriberAmount: 0,
    maxFileSize: 0,
    maxFileName: 0,
    removedRowsAmount: 0,
    resultFileId: '',
    validation: {
        error: '',
        isValid: false,
    },
    warningSettings: {
        defaultWarningRows: 0, 
        maxWarningRows: 0, 
        maxNumberWarningTextSymbols: 0,
    },
};

export enum EImportSubscribersLimitsField {
    DATE = 'date',
    STATUS = 'status',
    LIMIT = 'limit',
    MSISDN = 'msisdn',
    WARNING = 'warning'
}

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const WIZARD_IMPORT_SUBSCRIBERS_LIMITS_HANDLE_NEXT =
    '@@b2b_portal_ui/wizardImportSubscribersLimits/WIZARD_IMPORT_SUBSCRIBERS_LIMITS_HANDLE_NEXT';

export const WIZARD_IMPORT_SUBSCRIBERS_LIMITS_SET_PARAMS =
    '@@b2b_portal_ui/wizardImportSubscribersLimits/WIZARD_IMPORT_SUBSCRIBERS_LIMITS_SET_PARAMS';

export const WIZARD_IMPORT_SUBSCRIBERS_LIMITS_START_VALIDATE =
    '@@b2b_portal_ui/wizardImportSubscribersLimits/WIZARD_IMPORT_SUBSCRIBERS_LIMITS_START_VALIDATE';
export const WIZARD_IMPORT_SUBSCRIBERS_LIMITS_SET_STEP_VALID =
    '@@b2b_portal_ui/wizardImportSubscribersLimits/WIZARD_IMPORT_SUBSCRIBERS_LIMITS_SET_STEP_VALID';

/*
* -------------------------------------------
*          ATTACH FILE
* -------------------------------------------
*/

export const WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE =
    '@@b2b_portal_ui/wizardImportSubscribersLimits/WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE';
export const WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE_SUCCESSFUL =
    '@@b2b_portal_ui/wizardImportSubscribersLimits/WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE_SUCCESSFUL';
export const WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE_FAILED =
    '@@b2b_portal_ui/wizardImportSubscribersLimits/WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE_FAILED';

/*
* -------------------------------------------
*          LOAD TABLE DATA
* -------------------------------------------
*/
export const WIZARD_IMPORT_SUBSCRIBERS_LIMITS_INIT_VALIDATED_LIST =
    '@@b2b_portal_ui/wizardImportSubscribersLimits/WIZARD_IMPORT_SUBSCRIBERS_LIMITS_INIT_VALIDATED_LIST';

export const WIZARD_IMPORT_SUBSCRIBERS_LIMITS_INIT_VALIDATED_LIST_FAILED =
    '@@b2b_portal_ui/wizardImportSubscribersLimits/WIZARD_IMPORT_SUBSCRIBERS_LIMITS_INIT_VALIDATED_LIST_FAILED';
